import axios from 'axios';
import { apiUrl, config } from '../../../config.js';

async function getNewSessionId (oldId) {
  let response;
  try { response = await axios.get(`${apiUrl}/launch/reload?playerGameSessionId=${oldId}`, config) }
  catch (error) { return false; }
  console.log(response);

  return response.data;
}

async function getTomHornParams (data) {
  let response;
  config.params = data;
  try { response = await axios.get(`${apiUrl}/launch/thgameparameters`, config) }
  catch (error) { return Promise.reject(error) }

  return response.data;
}

export { getNewSessionId, getTomHornParams }
